/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]     .is-omnitracs{background-color:transparent!important;pointer-events:none!important;min-width:4rem!important}[_nghost-%COMP%]     .navbar-title{padding:0!important}[_nghost-%COMP%]     #notificationBtn{display:none!important}"];
export { styles as styles };
